import { createStylesWithTheme } from 'utils/functions';

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    alignItems: "center",
    textAlign: "center",
    maxHeight: "100dvh",
    padding: "44px 24px 32px 24px",
    overflow: "auto",
    backgroundColor: "#060b19",

  },
  headerLogoHorizontal: {
    minHeight: 42,
    height: 42,
    width: 'auto',
    marginBottom: 192,
  },
  subTitle: {
    marginTop: 16,
  },
  support: {
    marginTop: 8,
  },
  avatar: {
    maxWidth: 267,
    marginBottom: 24,
  },
};

export default createStylesWithTheme(styles);